module.exports = __webpack_public_path__ + "img/enote.17a29720.svg";